module.exports = "/img/_/_/_/assets/images/creeper/book/rare//8.jpg?2f3f802e5e95fefa7d228685c624bc56";